import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

type StyledTypes = {
  background?: string;
  color?: string;
  isLiftStationMobile?: boolean;
};

const StyledLabelTagBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})(({ background, color, isLiftStationMobile }: StyledTypes) => ({
  justifyContent: 'center',
  alignItems: 'center',
  width: isLiftStationMobile ? '55px' : '65px',
  minHeight: isLiftStationMobile ? '20px' : '22px',
  background: background,
  border: `1.5px solid ${color}`,
  borderRadius: '6px',
  padding: '0 2px',

  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
}));

const StyledLabelTagValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})(({ isLiftStationMobile }: StyledTypes) => ({
  fontSize: isLiftStationMobile ? '10px' : '11px',
  color: '#3B3B3B',
  fontWeight: '700',
}));

export { StyledLabelTagBox, StyledLabelTagValue };
